import { createStyles } from '@mantine/emotion';

export const useStyles = createStyles((theme) => ({
  root: {
    marginBottom: theme.spacing.sm,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row',
    width: '100%'
  },

  leftSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row',
    width: '80%'
  },

  group: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    width: '40%'
  },

  title: {
    fontSize: '14px'
  },

  description: {
    fontSize: '12px',
    color: theme.colors.brandGray[0]
  }
}));
